import { useMemo } from 'react';

export const usePricingVersion = () => {
  const shouldRenderV3 = useMemo(() => {
    // Check query parameter
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('pricingV3') === 'true') {
        return true;
      }
    }
    
    // Check Optimizely feature flag (if available)
    if (typeof window !== 'undefined' && (window as any).optimizely) {
      try {
        return (window as any).optimizely.getFeature('pricing_v3')?.isEnabled === true;
      } catch (error) {
        console.warn('Error checking Optimizely feature flag:', error);
      }
    }
    
    return false;
  }, []);

  return { shouldRenderV3 };
};

export default usePricingVersion;
